import { customerConstants } from "../_constants"

export default function customer(state = {}, action) {
    switch (action.type) {

        case customerConstants.CUSTOMER_GET_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case customerConstants.CUSTOMER_GET_LIST_SUCCESS:
            return {
                ...state,
                customer: action.customer.data,
                loading: false,
                error: false
            }
        case customerConstants.CUSTOMER_GET_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
        case customerConstants.CUSTOMER_ANALYTICS_COUNT_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case customerConstants.CUSTOMER_ANALYTICS_COUNT_SUCCESS:
            return {
                ...state,
                analyticsCount: action.customer.data,
                loading: false,
                error: false
            }
        case customerConstants.CUSTOMER_ANALYTICS_COUNT_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
        case customerConstants.SAVE_CUSTOMER_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case customerConstants.SAVE_CUSTOMER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false
            }
        case customerConstants.SAVE_CUSTOMER_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
        case customerConstants.CUSTOMER_SOFT_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case customerConstants.CUSTOMER_SOFT_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false
            }
        case customerConstants.CUSTOMER_SOFT_DELETE_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
        case customerConstants.GET_GRAPH_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case customerConstants.GET_GRAPH_LIST_SUCCESS:
            return {
                ...state,
                graphDataList: action.customer.data,
                loading: false,
                error: false
            }
        case customerConstants.GET_GRAPH_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
        case customerConstants.ASSIGN_CUSTOMER_GET_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: false
            };
        case customerConstants.ASSIGN_CUSTOMER_GET_LIST_SUCCESS:
            return {
                ...state,
                adminCustomer: action.customer.data,
                loading: false,
                error: false
            }
        case customerConstants.ASSIGN_CUSTOMER_GET_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: true
            }
            case customerConstants.GET_ALL_CUSTOMER_REQUEST:
                return {
                    ...state,
                    loading: true,
                    error: false
                };
            case customerConstants.GET_ALL_CUSTOMER_SUCCESS:
                return {
                    ...state,
                    allCustomer: action.customer.data,
                    loading: false,
                    error: false
                }
            case customerConstants.GET_ALL_CUSTOMER_FAILURE:
                return {
                    ...state,
                    loading: false,
                    error: true
                }
        default:
            return state
    }
}